import { usePage } from "@inertiajs/react";
import type { SharedProps } from "@/types";

// Over everything while an admin previews a brand, so it's never mistaken for
// the real thing — or left on. A plain link: turning it off reloads the whole
// page, CSS and all. Mirrors layouts/_brand_preview_bar.html.erb.
export default function BrandPreviewBar() {
  const { props, url } = usePage<SharedProps>();
  const brand = props.brand;
  if (!brand?.preview) return null;

  const path = url.split("?")[0];

  return (
    <div className="flex items-center justify-center gap-3 bg-gray12 px-4 py-1.5 text-sm text-gray1">
      <span>
        Previewing <strong>{brand.name}</strong>
      </span>
      <a href={`${path}?preview_brand=off`} className="font-semibold underline">
        Stop
      </a>
    </div>
  );
}
